export var GAMEPAD_TYPES = {
  no_gamepad: 'No Gamepad',
  //Dont change key no_gamepad. Value can be changed
  t3: "T3 Bluetooth GamePad",
  xbox: 'Xbox 360 GamePad',
  retro: 'Retro GamePad'
};
export var HARDWARE_TYPES = {
  ebot_sim: "Simulator: eBot",
  led_sim: "Simulator: LED",
  matrix_sim: "Simulator: Matrix",
  no_hardware: 'No ScratchLink Device',
  //Dont change key no_hardware. Value can be changed
  ebot_kit_crs: "eBot Kit CRS",
  ebot_mini_4wd: "eBot Mini 4WD",
  ebot_mini_omni: "eBot Mini Omni",
  ebot_mini_2wd: "eBot Mini 2WD",
  ebot_junior_omni_2dof: "eBot Junior Omni",
  ebot_junior_2wd_2dof: "eBot Junior 2WD",
  ebot_flipper_4wd_1dof: "eBot Flipper 4WD",
  ebot_pro_2wd_3dof: "eBot Pro 2WD",
  ebot_pro_omni_3dof: "eBot Pro Omni",
  ebot_scout_omni_5dof: "eBot Scout Omni",
  ebot_rescue_6wd_5dof: "eBot Rescue 6WD",
  servo_crane: "Servo Crane",
  stepper_crane: "Stepper Crane",
  drone_pad: "Drone Pad",
  conveyor_sorter: "Conveyor Sorter",
  traffic_lights: "Traffic Lights",
  solar_tracker: "Solar Tracker"
};
export var BLOCK_LEVEL_TYPES = {
  BEGINNER: 'Beginner',
  CORE: 'Core',
  ADVANCED: 'Advanced'
};
export var PROJECT_TYPES = {
  DEMO: 'Demo',
  CODINGPROJECT: 'Coding Challenge',
  CUSTOM: 'Custom',
  EXAMPLE: 'Example'
};